import {ResponsiveService} from './../../../../../../core/services/responsive.service';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {MatDialog} from '@angular/material/dialog';
import {Component, OnInit, Input, ViewChild, AfterViewInit, OnDestroy, ViewChildren, ChangeDetectorRef} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {DataSource, SelectionModel} from '@angular/cdk/collections';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {Subscription, BehaviorSubject, Observable, merge, of, ReplaySubject, Subject} from 'rxjs';
import {NotificationService} from 'src/app/core/services/notification.service';
import {CommonService} from 'src/app/core/services/common.service';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {Message} from 'src/app/core/class/message';
import {tap, takeUntil, take, map, catchError, filter, switchMap} from 'rxjs/operators';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ToastrService} from 'ngx-toastr';
import {CdkDetailRowDirective} from 'src/app/shared/directive/cdk-detail-row.directive';
import {Router, ActivatedRoute} from '@angular/router';
import {DocumentService} from 'src/app/core/services/document.service';
import {UserService} from 'src/app/core/services/user.service';
import {DocumentTypeService} from 'src/app/core/services/document-type.service';
import {BranchService} from 'src/app/core/services/branch.service';
import {NgForm, FormControl} from '@angular/forms';
import {MatSelect} from '@angular/material';
import {Common, DateFormat, EnumDownloadMenuName} from 'src/app/core/constants/common';
import {
  EnumContractStatus,
  EnumContractUserRole,
  EnumContractSendBCTStatus,
  EnumColumnTable, EnumContractUserStatus
} from '../../../../../../core/constants/contract';
import {WarningSmsContractService} from 'src/app/core/services/warning-sms-contract.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ErrorCode} from '../../../../../../core/constants/error-code';
import dayjs from 'dayjs';
import {DatePipe} from '@angular/common';
import {MultiDownloadService} from '../../../../../../core/services/multi-download.service';
import { ConfirmTerminationComponent } from '../search-document-mine/confirm-termination/confirm-termination.component';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {ContractService } from 'src/app/core/services/contract.service';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';

@Component({
  selector: 'app-search-document-contract-company',
  templateUrl: './search-document-contract-company.component.html',
  styleUrls: ['./search-document-contract-company.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
      state('*', style({height: '*', visibility: 'visible'})),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SearchDocumentContractCompanyComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Check status of document for process update
   */
  @BlockUI() blockUI: NgBlockUI;
  checkUpdateDocument = false;
  isDisableNamePhoneEmail = true;
  private EventWarningContractSubscription: Subscription;
  public warningContractQuantity = false;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  isNotAttestedUser: boolean = false;
  isVContract: boolean = true;

  constructor(
    private documentTypeService: DocumentTypeService,
    private usService: UserService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private branchService: BranchService,
    private warningSmsContractService: WarningSmsContractService,
    public deviceService: DeviceDetectorService,
    private responsiveService: ResponsiveService,
    private datepipe: DatePipe,
    private downloadService: MultiDownloadService,
    private cdr: ChangeDetectorRef,
    private contractService: ContractService,
    private documentMohaService: DocumentMohaService
  ) {
    super(commonService, message);
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };

    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }
  enumColumnTable = EnumColumnTable;
  enumContractStatus = EnumContractStatus;
  enumContractUserRole = EnumContractUserRole;
  enumContractSendBCTStatus = EnumContractSendBCTStatus;
  documentTypeEnterprise = {
    documentTypeId: 0,
    name: '',
    parentId: null,
    serviceTypeId: null
  };


  documentEnterprise = {
    documentId: 0,
    name: '',
    parentId: null,
    id: null
  };

  columnDefinitions = [
    //{def: 'select', default: true , showMD: true, showMobile: true, name: '', check: true},
    {def: 'STT', default: true , showMD: true, showMobile: true, name: '', check: true},
    {def: 'uuidContractMoha', default: true , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.uuid_Contract', check: true},
    {def: 'name', default: true , showMD: true, showMobile: true, name: '', check: true},
    {def: 'allName', default: true , showMD: true, showMobile: false, name: 'headertable.contract_parties', check: true},
    {def: 'allEmail', default: true , showMD: true, showMobile: false, name: 'headertable.contract_parties_email', check: true},
    {def: 'serviceTypeName', default: true , showMD: true, showMobile: false, name: 'form.service_type', check: true},
    {def: 'status', default: true , showMD: true, showMobile: false, name: 'enterprise_contract.table_headers.document_status', check: true},
    {def: 'createdUser', default: true , showMD: true, showMobile: false, name: 'enterprise_contract.table_headers.created_by', check: true},
    {def: 'createdTime', default: true , showMD: true, showMobile: false, name: 'enterprise_contract.table_headers.created_date', check: true},
    {def: 'statusRecipient', default: false , showMD: true, showXS: false, showSM: false,  name: 'headertable.recipient_status', check: false},
    {def: 'statusOriginator', default: false , showMD: true, showXS: false, showSM: false,  name: 'headertable.opposite_status', check: false},
    {def: 'expiredDate', default: false , showMD: true, showXS: false, showSM: true, name: 'enterprise-certificate_management.lbl_end_date', check: false},
    {def: 'submittedByATime', default: false , showXS: false, showSM: false, showMD: true, name: 'searchDocumentMine.lbl_submitByATime', check: false},
    {def: 'expireStatus', default: false , showXS: false, showSM: false, showMD: true, name: 'searchDocumentMine.lbl_validity', check: false},
    {def: 'mohaConfirmStatus', default: true , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.status_send_up', check: true},
    {def: 'mohaStatus', default: true , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.status_sign', check: true},
    {def: 'contractMohaErrorDescription', default: false , showXS: false, showSM: false, showMD: true, name: 'header.reason', check: false},
    {def: 'customerGroups', default: false , showXS: false, showSM: false, showMD: true, name: 'form.group_customer', check: false},
    {def: 'typeId', default: false , showXS: false, showSM: false, showMD: true, name: 'search_form.method_creation', check: false},
    //{def: 'formType', default: false , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.form_type', check: false},
    {def: 'action', default: true , showMD: true, showMobile: true, name: '', check: true},

  ];
  tableWidth = 950;
  isCheckedAllColumn: boolean = false;

  // displayedColumns: string[] = [
  //   'STT',
  //   'name',
  //   'allName',
  //   'serviceTypeName',
  //   'status',
  //   'createdUser',
  //   'createdTime',
  //   'action',
  // ];
  enumContractUserStatus = EnumContractUserStatus;
  selection = new SelectionModel<string>(true, []);

  displayedColumns: string[] = [];

  displayedChildColumns: string[] = [
    'STT',
    'name',
    'allName',
    'allEmail',
    'serviceTypeName',
    'status',
    //'bctConfirmStatus',
    'createdUser',
    'createdTime',
    'customerGroups',
    'action',
  ];

  documents = new Document();

  checkFocus = true;
  dataSource: DocumentDataSource;
  childDataSourceList: DocumentTypeDataSourceKeyPair = {};

  paginate: Paginate;
  childPaginateList: PaginateKeyPair = {};

  oldData = this.documents;
  childOldDataList: DocumentKeyPair = {};

  isFirstLoad = true;
  isTableLoading = false;
  // Plan A: list API chi duoc goi sau khi API cau hinh cot (user-config) da tra ve
  // signal bat = true sau khi getColumnByUser() da ap config + getDisplayedColumns()
  private columnConfigLoaded$ = new BehaviorSubject<boolean>(false);
  childIsFirstLoadList: BooleanKeyPair = {};

  childIsExexpanding: Array<string>;

  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('myForm', {static: false}) ngForm: NgForm;
  @ViewChild('statusSelect', {static: false}) statusSelect: MatSelect;
  @ViewChild('serviceTypeSelect', {static: false}) serviceTypeSelect: MatSelect;
  @ViewChild('signRoleSelect', {static: false}) signRoleSelect: MatSelect;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('typeIdSelect', {static: false}) typeIdSelect: MatSelect;
  @ViewChild('formTypeSelect', {static: false}) formTypeSelect: MatSelect;
  @ViewChild('formTypeSelectSend', {static: false}) formTypeSelectSend: MatSelect;

  childSortList: SortKeyPair = {};

  sortDirection = 'ASC';
  childSortDirection: StringKeyPair = {};

  sortColumn = 'name';
  sortChildColumn: StringKeyPair = {};

  error = '';
  subscription: Subscription;
  expanded = [];
  openedRow: CdkDetailRowDirective;
  parentDocuments: Document[];

  isDocumentManager: boolean;
  enterpriseId: string;

  // List all parent branches
  //parentBranches: { id: string, name: '' }[];
  // Selected model value for autocomplete
  selectedBranch: { id: string, name: '' };

  // List all parent branches
  documentTypes: comboBox[] = [];
  serviceTypes: comboBox[] = [];

  documentTypesFilterCtrl: FormControl = new FormControl();
  serviceTypesFilterCtrl: FormControl = new FormControl();

  public filteredDocumentTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();

  isBasicSearchForm = true;

  createdDateErr: string = '';
  finishedDateErr: string = '';

  @Input() singleChildRowDetail: boolean;


  isExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.commonService.getEnterpriseFilterMineServiceType(enterpriseId).subscribe(rs => {
      if (rs && rs.data) {
        const filtered = rs.data.filter(item => item.isEmploymentContract === true);
        this.serviceTypes = filtered;
        this.filteredServiceTypes.next(filtered.slice());
        this.documents.serviceType = parseInt(this.documents.serviceType);
      }
    });
  }

  ngOnInit() {
    this.getColumnByUser().subscribe();
    if (this.commonService.checkEnterpriseType()) {
      this.isVContract = false;
    }
    // if (this.isVContract) {
    //   this.columnDefinitions.splice(-4, 0, {def: 'bctConfirmStatus', default: true , showMD: true, showMobile: false, name: '', check: true},);
    //   this.displayedChildColumns.splice(-4, 0, 'bctConfirmStatus');
    // }
    this.documentTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.documentTypes, this.documentTypesFilterCtrl, this.filteredDocumentTypes);
        });

    this.serviceTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
        });

    this.getServiceTypeByEnterprise();

    this.isDocumentManager = true;
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.dataSource = new DocumentDataSource();
    this.loadData();
    //this.getParentBranches();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);

    this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
    this.EventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
      (response) => {
        if (response.isBuyContract10Mb && !response.isBuyContract1Mb) {
          if (response.contractQuantity <= 0) {
            this.warningContractQuantity = true;
          }
        } else if (!response.isBuyContract10Mb && response.isBuyContract1Mb) {
          if (response.contract1MbQuantity <= 0) {
            this.warningContractQuantity = true;
          }
        } else if (response.isBuyContract10Mb && response.isBuyContract1Mb) {
          if (response.contract1MbQuantity <= 0 && response.contractQuantity <= 0) {
            this.warningContractQuantity = true;
          }
        } else {
          this.warningContractQuantity = true;
        }
      }
    );
  }

  getColumnByUser(): Observable<boolean> {
    return this.documentService.getColumnDynamic('CREATE_DOCUMENT').pipe(
      take(1),
      catchError(() => of(false)),
      tap(rs => {
        if (rs && rs.success) {
          if (rs.data) {
            const check = JSON.parse(rs.data);
            const recordsWithDefaultTrue = check.find(item => item.default === false);
            if (recordsWithDefaultTrue) {
              this.isCheckedAllColumn = false;
            } else {
              this.isCheckedAllColumn = true;
            }
            this.columnDefinitions = this.columnDefinitions.map(ele => {
              const checkDef = check.find(item => item.def === ele.def);
              return checkDef ? {...ele, default: checkDef.default} : ele;
            });
          }
        } else if (rs && !rs.success) {
          this.toastr.error(this.message.getMessage('messages.update_certificate_renew_server_error'));
        }
        // chi ap config va mo khoa list API; getDisplayedColumns() chay trong callback list
        // cung tick voi data -> header + data render cung 1 lan, khong trang thai trung gian
        this.columnConfigLoaded$.next(true);
      }),
      map(() => true)
    );
  }


  onCheckboxChange(column: any) {
    const recordsWithDefaultTrue = this.columnDefinitions.find(item => item.default === false);
    if (recordsWithDefaultTrue) {
      this.isCheckedAllColumn = false ;
    } else {
      this.isCheckedAllColumn = true ;
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    const codeColumnByUser = {
      code: "CREATE_DOCUMENT",
      value: JSON.stringify(this.columnDefinitions.map(item => ({
        def: item.def,
        default: item.default
      })))
    };
    this.documentService.saveColumnDynamic(codeColumnByUser)
      .subscribe(res => {
      });
  }

  onAllColumnCheckboxChange(isCheck: any) {
    if (isCheck) {
      this.columnDefinitions.forEach((column) => {
        column.default = true;
      });
    } else {
      this.columnDefinitions.forEach((column) => {
        if (!column.check) {
          column.default = false;
        }
      });
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    const codeColumnByUser = {
      code: "CREATE_DOCUMENT",
      value: JSON.stringify(this.columnDefinitions.map(item => ({
        def: item.def,
        default: item.default
      })))
    };
    this.documentService.saveColumnDynamic(codeColumnByUser)
      .subscribe(res => {
      });
  }

  changeWidthTable() {
    const check = this.columnDefinitions.filter(item => item.default === true);
    if (this.mediaBreakpoint === SCREEN_SIZE.MD ) {
      this.tableWidth = 1650 ;
    } else {
      if (check.length > 11) {
        this.tableWidth = 1650;
      } else if (check.length <= 11) {
        this.tableWidth = 950;
      }
    }
  }


  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
      this.tableWidth = 300 ;
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD && cd.default)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.filter(cd => cd.default).map(cd => cd.def);
      }
      this.changeWidthTable();
    }
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    merge(this.sort.sortChange, page)
      .pipe(
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.EventWarningContractSubscription.unsubscribe();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.downloadService.clearData();
  }

  /**
   * Get parent branches for creating branch
   */
  // getParentBranches() {
  //   const enterpriseId = localStorage.getItem('enterpriseId');
  //   this.usService.getAllChild(
  //     enterpriseId
  //   ).subscribe(rs => {
  //     if (rs == null || rs.data == null) {
  //       return 0;
  //     }
  //     this.parentBranches = rs.data;
  //   });
  // }

  /**
   * Detect value changing in autocomplete input
   */
  onChangeAutoCompleted() {
    if (this.selectedBranch == null || this.selectedBranch == undefined) {
      this.oldData.enterprise = '';
      this.documentTypes = null;
      this.filteredDocumentTypes.next(this.documentTypes.slice());
      this.serviceTypes = null;
      this.filteredServiceTypes.next(this.serviceTypes.slice());
    } else if (this.selectedBranch != null && this.selectedBranch != undefined) {
      this.oldData.enterprise = this.selectedBranch.id;
      this.documentTypeService.getByEnterprise(this.oldData.enterprise).subscribe(documentTypes => {
        const result = documentTypes.data;
        this.documentTypes = result;
        this.filteredDocumentTypes.next(this.documentTypes.slice());
      });
      this.commonService.getTypeOfDocument(this.oldData.enterprise).subscribe(types => {
        const result = types.data;
        this.serviceTypes = result;
        this.filteredServiceTypes.next(this.serviceTypes.slice());
      });
    }
  }

  // getCECAStatus(element) {
  //   let statusString = 'Hoàn thành';
  //   switch (element.bctConfirmStatus) {
  //     case this.enumContractStatus.DRAFT:
  //     case this.enumContractStatus.PROCESSING:
  //       statusString = 'Đang xử lý xác thực lên trục BCT';
  //       break;
  //     case this.enumContractStatus.REJECTED:
  //       statusString = 'Xác thực lên trục BCT thất bại';
  //       break;
  //     case this.enumContractStatus.FINISHED:
  //       statusString = 'Xác thực lên trục BCT thành công';
  //       break;
  //     default:
  //       statusString = 'Trạng thái không xác định';
  //   }
  //   return statusString;
  // }

  // getConfirmBCTStastus(element) {
  //   if (!element.isConfirmBCT) {
  //     return 'headertable.bct_cancel';
  //   }

  //   switch (element.bctConfirmStatus) {
  //     case this.enumContractSendBCTStatus.PROCESSING:
  //       return 'headertable.bct_process';
  //     case this.enumContractSendBCTStatus.ERROR:
  //       return 'headertable.bct_error';
  //     case this.enumContractSendBCTStatus.FINISHED:
  //       return 'headertable.bct_finish';
  //     case this.enumContractSendBCTStatus.NEW:
  //       return 'headertable.bct_new';
  //     case this.enumContractSendBCTStatus.CANCELLED:
  //       return 'headertable.bct_cancel';
  //     default:
  //       return 'headertable.bct_new';
  //   }
  // }

  getFilterCondition(page: number, pageSize: number, data): any {
    const {
      enterpriseContain,
      documentTypeContain,
      customer,
      nameOrCodeContain,
      taxCode,
      statusContain,
      nameOrCode,
      createdTimeFrom,
      createdTimeTo,
      finishDateFromContain,
      finishDateToContain,
      parentContainID,
      serviceType,
      customerName,
      createdUser,
      createdEnterpriseName,
      status,
      signRole,
      nameOrEmailOrPhoneUserSign,
      parentID,
      //bctConfirmStatus,
      typeId,
      certificateNo,
      contractCodeName,
      formType,
      uuidContractMoha,
      mohaStatus,
      mohaConfirmStatus,
    } = data;
    let filterCondition: any = {
      enterpriseId: enterpriseContain,
      docsTypeId: documentTypeContain, // mau tai lieu
      nameOrCode,
      status: status,
      signRole: signRole,
      nameOrEmailOrPhoneUserSign: nameOrEmailOrPhoneUserSign,
      parentId: parentID,
      customer: customerName,
    // bctConfirmStatus: bctConfirmStatus === 'null' || bctConfirmStatus === null ? null : +bctConfirmStatus,
      page,
      pageSize,
    };


    if (!this.isBasicSearchForm) {
      filterCondition = {
        ...filterCondition,
        createdTimeFrom,
        createdTimeTo,
        taxCode,
        createdUser,
        finishDateFrom: finishDateFromContain,
        finishDateTo: finishDateToContain,
        serviceType: serviceType,
        createdEnterpriseName,
      //  bctConfirmStatus: bctConfirmStatus === 'null' || bctConfirmStatus === null ? null : +bctConfirmStatus,
        signRole: signRole,
        nameOrEmailOrPhoneUserSign: nameOrEmailOrPhoneUserSign,
        typeId,
        formType,
        uuidContractMoha,
        mohaStatus,
        mohaConfirmStatus,
      };
    }

    if(this.checkPermissionLimitedViewContract()){
      filterCondition = {
        certificateNo,
        contractCodeName,
        page,
        pageSize,
      }
    }

    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection;
    sortColumn = this.sortColumn; // is searching in parent
    let column = null;

    switch (sortColumn) {
      case 'name':
        column = {
          contractName: sortDirection
        };
        break;
      case 'createdTime':
        column = {
          createdTime: sortDirection
        };
        break;
      case 'createdUser':
        column = {
          creator: sortDirection
        };
        break;
      case 'serviceTypeName':
        column = {
          serviceType: sortDirection
        };
        break;
      default:
        break;
    }

    filterCondition['sorts'] = column;

    return filterCondition;
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  /**
   * Get data when init
   */
  loadData(page: number = 0, pageSize: number = 10) {
    if(!this.checkPermissionLimitedViewContract()){
      let paramDocumentType: '';
      let paramEnterprise: '';
      let paramNameOrCode: '';
      let paramCustomerName: '';
      let paramStatus: '';
      let paramBTCStatus: '';
      let paramServiceType: '';
      let paramTaxCode: '';
      let paramCreatedUser: '';
      let paramCreatedTimeFrom: any;
      let paramCreatedTimeTo: any;
      let paramFinishDateFrom: any;
      let paramFinishDateTo: any;
      let paramSignRoles: any;
      let paramNameOrEmailOrPhoneUserSign: '';
      let paramFormType: '';
      let paramUuidContractMoha: '';
      let paramMohaStatus: number;
      let paramMohaConfirmStatus: number;

      this.subscription = this.route
        .queryParams
        .subscribe(params => {
          paramEnterprise = params.enterprise;
          paramDocumentType = params.documentType;
          paramNameOrCode = params.nameOrCode;
          paramCustomerName = params.customerName;
        //  paramBTCStatus = params.bctConfirmStatus;
          paramStatus = params.status;
          paramFormType = params.formType;
          // paramStatus = Common.DOCUMENT_STATUS.indexOf(params.status) == -1 ? 'null' : params.status;
          paramStatus = params.status == 'totalDocumentsSigned' ? 2
            : params.status == 'totalDocumentsWaitingForPartnersToSign' ? 8
              : params.status == 'totalDocumentsWaitingForSigning' ? 1
                : params.status == 'totalDocumentsDenied' ? 3
                  : params.status == 'totalDocumentsRejectedByPartners' ? 6
                    : params.status == 'totalDocumentsFinish' ? 7
                      : params.status;
          paramServiceType = (params.serviceType && params.serviceType != 'NaN') ? params.serviceType : null;
          paramTaxCode = params.taxCode;
          paramCreatedUser = params.createdUser;
          paramCreatedTimeFrom = params.createdTimeFrom != null ? new Date(params.createdTimeFrom) : null;
          paramCreatedTimeTo = params.createdTimeTo != null ? new Date(params.createdTimeTo) : null;
          paramFinishDateFrom = params.finishDateFrom != null ? new Date(params.finishDateFrom) : null;
          paramFinishDateTo = params.finishDateTo != null ? new Date(params.finishDateTo) : null;
          page = params.page || 0;
          pageSize = params.pageSize && params.pageSize > 0 ? params.pageSize : 10;
          this.sortColumn = params.sortColumn != null ? params.sortColumn : null;
          this.sortDirection = params.sortDirection != null ? params.sortDirection : null;
        });

      this.documents.enterprise = paramEnterprise;
      this.documents.documentType = paramDocumentType;
      this.documents.nameOrCode = paramNameOrCode;
      this.documents.customerName = paramCustomerName;
      this.documents.status = paramStatus ? Number(paramStatus) : null;
    //  this.documents.bctConfirmStatus = paramBTCStatus ? paramBTCStatus : null;
      this.documents.serviceType = paramServiceType ? paramServiceType : 'null';
      this.documents.taxCode = paramTaxCode;
      this.documents.createdUser = paramCreatedUser;
      this.documents.createdTimeFrom = paramCreatedTimeFrom;
      this.documents.createdTimeTo = paramCreatedTimeTo;
      this.documents.finishDateFrom = paramFinishDateFrom;
      this.documents.finishDateTo = paramFinishDateTo;
      this.documents.signRole = paramSignRoles ? Number(paramSignRoles) : null;
      this.documents.nameOrEmailOrPhoneUserSign = paramNameOrEmailOrPhoneUserSign;
      this.documents.formType = paramFormType;
      if (paramEnterprise) {
        this.getBranch(paramEnterprise);
      }

      if (paramServiceType || paramTaxCode || paramCreatedUser
        || paramCreatedTimeFrom || paramCreatedTimeTo  || paramFormType
        || paramFinishDateFrom || paramFinishDateTo) {
        this.isBasicSearchForm = false;
      }
    } else {
      let paramCertificateNo: '';
      let paramContractCodeName: '';
      this.subscription = this.route
        .queryParams
        .subscribe(params => {
          paramCertificateNo = params.certificateNo;
          paramContractCodeName = params.contractCodeName;

          page = params.page || 0;
          pageSize = params.pageSize && params.pageSize > 0 ? params.pageSize : 10;
          this.sortColumn = params.sortColumn != null ? params.sortColumn : null;
          this.sortDirection = params.sortDirection != null ? params.sortDirection : null;
        });
        this.documents.certificateNo = paramCertificateNo;
        this.documents.contractCodeName = paramContractCodeName;
    }

    // if (this.parentBranches) {
    //   this.selectedBranch = this.parentBranches.find(x => {
    //     return x.id === paramEnterprise;
    //   });
    // }

    // DESC or ASC
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }

    if(!this.checkPermissionLimitedViewContract()){
      this.isTableLoading = true;
      // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
      // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
      this.dataSource.setData([]);
      // Plan A: cho config cot tra ve roi moi goi list -> data luon render dung theo cot da cap nhat
      this.columnConfigLoaded$.pipe(
        filter(loaded => loaded),
        take(1),
        switchMap(() => this.documentService.searchDocumentContractCompany(this.getFilterCondition(page, pageSize, this.documents)))
      )
      .subscribe(rs => {
        // doi header theo config BE; CD tick chay ngay sau callback se re-render header theo cot moi
        this.getDisplayedColumns();
        if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
          && rs.data.totalRow != null) {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
        }
        console.log('searchDoc::', rs.data);
        // data render trong macrotask sau CD tick -> rowDef.columns da cap nhat xong,
        // row luon dung theo cot config; an skeleton cung luc de header + data len cung thoi diem
        setTimeout(() => {
          this.isTableLoading = false;
          if (rs.data && rs.data.dataRow != null) {
            this.initParent(rs);
          }
        });
      }, () => this.isTableLoading = false);
    } else {
      this.isTableLoading = true;
      this.dataSource.setData([]);
      this.columnConfigLoaded$.pipe(
        filter(loaded => loaded),
        take(1),
        switchMap(() => this.documentService.searchDocumentLimit(this.getFilterCondition(page, pageSize, this.documents)))
      )
      .subscribe(rs => {
        this.getDisplayedColumns();
        if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
          && rs.data.totalRow != null) {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
        }
        setTimeout(() => {
          this.isTableLoading = false;
          if (rs.data && rs.data.dataRow != null) {
            this.initParent(rs);
          }
        });
      }, () => this.isTableLoading = false);
    }
  }

  /**
   * Get inform of branch
   */
  getBranch(branchId: number) {
    this.branchService.getBranch(branchId).subscribe(
      rs => {
        this.selectedBranch = {
          id: String(branchId),
          name: rs.data.name
        };
      }
    );
  }

  initChild(rs: any, parentID: string): void {
    let stt = this.childPaginateList[parentID].pageSize * this.childPaginateList[parentID].currentPage + 1;
    const childs = rs.data.dataRow as Document[];

    childs.forEach(child => {
      child.taxCode = (child.customerTaxCode == null || child.customerTaxCode === '') ?
        child.customerCertificateNo : child.customerTaxCode;
      child['STT'] = stt++;
      child.parentId = parentID;
    });
  }

  initParent(rs: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
    this.parentDocuments = rs.data.dataRow;
    this.parentDocuments.forEach(parent => {
      parent.taxCode = (parent.customerTaxCode == null || parent.customerTaxCode === '') ?
        parent.customerCertificateNo : parent.customerTaxCode;
      parent['STT'] = stt++;
      this.childPaginateList[parent.id] = new Paginate();
      this.childOldDataList[parent.id] = new Document();
      this.childSortList[parent.id] = new MatSort();
    });
    this.dataSource.setData(this.parentDocuments);
    // console.log('dataSource::', this.dataSource);
    this.childIsExexpanding = [];
  }

  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortColumn = sort.active;
  }

  sortChildData(sort: Sort, parentID: string) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortChildColumn[parentID] = sort.active;
    this.childSortList[parentID].direction = sort.direction;

    this.onFilterChildData(
      this.childPaginateList[parentID].currentPage,
      this.childPaginateList[parentID].pageSize, parentID);
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }

    if(!this.checkPermissionLimitedViewContract()){
      if (this.isBasicSearchForm) {
        this.documents.createdTimeFrom = null;
        this.documents.createdTimeTo = null;
        this.documents.serviceType = null;
       // this.documents.bctConfirmStatus = null;
        this.documents.createdUser = '';
        this.documents.nameOrEmailOrPhoneUserSign = null;
        this.documents.signRole = null;
        this.isDisableNamePhoneEmail = true;
      }
      // set null for document model
      this.oldData.nameOrCode = this.oldData.nameOrCode || null;
      this.oldData.customerName = this.oldData.customerName || null;
      this.oldData.taxCode = this.oldData.taxCode || null;
      this.oldData.createdUser = this.oldData.createdUser || null;
      this.oldData.createdTimeFrom = this.oldData.createdTimeFrom || null;
      this.oldData.createdTimeTo = this.oldData.createdTimeTo || null;
      this.oldData.finishDateFrom = this.oldData.finishDateFrom || null;
      this.oldData.finishDateTo = this.oldData.finishDateTo || null;
      this.oldData.nameOrEmailOrPhoneUserSign = this.oldData.nameOrEmailOrPhoneUserSign || null;
      this.oldData.signRole = this.oldData.signRole || null;
     //this.oldData.bctConfirmStatus = this.oldData.bctConfirmStatus || 'null';
      this.isDisableNamePhoneEmail = (this.oldData.signRole === null) ? true : this.isDisableNamePhoneEmail;
      this.oldData.uuidContractMoha = this.oldData.uuidContractMoha || null;
      // this.oldData.mohaStatus = this.oldData.mohaStatus || null;
      // this.oldData.mohaConfirmStatus = this.oldData.mohaConfirmStatus || null;

      if (this.isBasicSearchForm) {
        this.documents.signRole = null;
        this.documents.nameOrEmailOrPhoneUserSign = '';
      }

      this.isTableLoading = true;
      // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
      // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
      this.dataSource.setData([]);
      // Plan A: cho config cot tra ve roi moi goi list (lan dau; cac lan filter sau signal da bat)
      this.columnConfigLoaded$.pipe(
        filter(loaded => loaded),
        take(1),
        switchMap(() => this.documentService.searchDocumentContractCompany(this.getFilterCondition(page, pageSize, this.oldData)))
      )
      .subscribe(
        rs => {
          this.getDisplayedColumns();
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
          setTimeout(() => {
            this.isTableLoading = false;
            this.initParent(rs);

            if (this.isBasicSearchForm) {
              this.documents.createdTimeFrom = null;
              this.documents.createdTimeTo = null;
              this.documents.serviceType = null;
             // this.documents.bctConfirmStatus = null;
              this.documents.createdUser = '';
              this.documents.signRole = null;
              this.documents.nameOrEmailOrPhoneUserSign = '';
              this.isDisableNamePhoneEmail = true;
            }
          });
        }
        , () => this.isTableLoading = false
      );
    } else {
      this.oldData.certificateNo = this.oldData.certificateNo || null;
      this.oldData.contractCodeName = this.oldData.contractCodeName || null;
      this.isTableLoading = true;
      this.dataSource.setData([]);
      this.columnConfigLoaded$.pipe(
        filter(loaded => loaded),
        take(1),
        switchMap(() => this.documentService.searchDocumentLimit(this.getFilterCondition(page, pageSize, this.oldData)))
      )
      .subscribe(
        rs => {
          this.getDisplayedColumns();
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
          setTimeout(() => {
            this.isTableLoading = false;
            this.initParent(rs);
          });
        }
        , () => this.isTableLoading = false
      );
    }


  }

  onFilterChildData(page: number = 0, pageSize: number = 10, parentID: string) {

    if (this.childIsFirstLoadList[parentID] === false) {
      if (this.childSortList[parentID].direction === 'asc') {
        this.childSortDirection[parentID] = 'ASC';
      } else if (this.childSortList[parentID].direction === 'desc') {
        this.childSortDirection[parentID] = 'DESC';
      }

    } else {
      this.childIsFirstLoadList[parentID] = false;
    }

    this.documentService.searchChildDocument(this.getFilterCondition(page, pageSize, {...this.oldData, parentID}))
      .subscribe(
        rs => {
          this.childPaginateList[parentID] = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };

          this.initChild(rs, parentID);
          this.childDataSourceList[parentID].setData(rs.data.dataRow);
        }
      );
  }

  closeExpandCollapse() {
    document.getElementById('noSpanTable').click();
  }

  expandedParent(parentID: string) {
    if (this.childIsExexpanding.includes(parentID)) {
      const index = this.childIsExexpanding.indexOf(parentID, 0);
      if (index > -1) {
        this.childIsExexpanding.splice(index, 1);
      }
      return;
    } else {
      this.childIsExexpanding.push(parentID);
    }
    this.childDataSourceList[parentID] = null;

    /* add child to parent to show  */
    this.parentDocuments.forEach(parentDocumentType => {
      if (parentDocumentType.id === parentID) {
        this.documentService.searchChildDocument(this.getFilterCondition(0, 10, {...this.oldData, parentID}))
          .subscribe(rs => {
            if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
              && rs.data.totalRow != null) {
              this.childPaginateList[parentID] = {
                currentPage: rs.data.currentPage,
                pageSize: rs.data.pageSize,
                totalRow: rs.data.totalRow,
                totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
                totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
                no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
              };
            }
            if (rs.data && rs.data.dataRow != null) {

              this.childDataSourceList[parentID] = new DocumentDataSource();
              this.childDataSourceList[parentID].setData(rs.data.dataRow);
              this.initChild(rs, parentID);
            }
          });
      }
    });
  }

  /**
   * Delete document
   * xóa
   */
  delete(id: any, parentId: string = null, documentName: string) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_docs'), documentName)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.documentService.delete(id).subscribe(() => {
          this.toastr.success(this.message.getMessage('messages.delete_success'));
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          }
          // is parent element
          if (parentId == null || parentId === '') {
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          } else {
            this.onFilterChildData(
              this.childPaginateList[parentId].currentPage,
              this.childPaginateList[parentId].pageSize, parentId);
          }
        });
      }
    });
  }

  /**
   * Open dialog Update
   * @param element model document
   */
  onUpdate(element) {
    this.getDocumentById(element.id);
  }

  /**
   * Get document type by id to check status of document type
   */
  checkStatusDocumentType(documentId: string, documentTypeEnterpriseId: string, callback: () => void, error: string) {
    this.documentTypeService.findById(documentTypeEnterpriseId).subscribe(rs => {
      if (rs.data.status && rs.data.relationStatus) {
        callback();
      } else {
        if (!this.toastr.findDuplicate(this.message.getMessage(error), true, true)) {
          this.toastr.error(this.message.getMessage(error));
        }
      }
    });
  }

  /**
   * Get document by id.
   * @param id the document id.
   */
  getDocumentById(id: string) {
    if (id) {
      this.documentService.getDocumentById(id).subscribe(rs => {
        if (rs.data.contractDTO.typeId == 0) {
          this.checkStatusDocumentType(id, rs.data.contractDTO.documentTypeEnterpriseId, () => {
            this.toNavigate('/home-enterprise/update-document/' + id, {goFrom: 'enterprise_company', typeUpdate: true});
          }, 'messages.document_stop');
        } else {
          this.toNavigate('/home-enterprise/update-document/' + id, {goFrom: 'enterprise_company', typeUpdate: true});
        }
      });
    }
  }

  /**
   * Navigate to view detail document
   */
  viewDetail(id, type?) {
    if (type) {
      this.toNavigate('/home-enterprise/view-document-moha/' + id, {goFrom: 'enterprise_company', typeCopy: type});
    } else {
      this.toNavigate('/home-enterprise/view-document-moha/' + id, {goFrom: 'enterprise_company'});
    }
  }

  /**
   * Open PDF By Browser
   */
  openPDFByBrowser(response: any, fileName: string) {
    const blobUrl = URL.createObjectURL(response);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName + '.zip';
    a.click();
  }

  singleDownload(documentData: Document) {
    if (documentData.id) {
      this.documentService.downloadFileZip(documentData.id).subscribe(res => {
        console.log(typeof res);
        this.openPDFByBrowser(res, documentData.name);
      });
    }
  }

  multiDownload() {
    this.downloadService.setData({
      contractIds: this.selection.selected,
      menuContract: EnumDownloadMenuName.SEARCH_DOCUMENT,
    });
  }

  /**
   * Copy document
   */
  copyDocument(id: string, type?: any) {
    if (id) {
      if (this.documents.documentType === 1) {
        this.toastr.error(this.message.getMessage('messages.document_no_copy'));
      } else {
        this.documentService.checkTemplate(id).subscribe(rs => {
          if (rs && rs.code === ErrorCode.DocumentInactive) {
            this.toastr.error(this.message.getMessage('messages.copy_contract_error_template_inactive'));
            return;
          }
          if (rs && rs.code === ErrorCode.CopyNotPermission) {
            this.toastr.error(rs.message);
            return;
          }
          this.documentService.checkContractTerminationCopy(id).subscribe(res =>{
            if (res.success) {
              this.toNavigate('/home-enterprise/update-document/' + id, {
                flagCopy: true,
                goFrom: 'mine',
                typeCopy: type
              });
            } else {
              this.toastr.error(res.message)
            }
          })
        });
      }
    }
  }

  onClickBtnFilter() {
    this.oldData = this.documents;
    this.addColumnTable();
    // if (!((this.documents.signRole == null || this.documents.signRole == 'null' ) || this.documents.nameOrEmailOrPhoneUserSign == null) ) {
    //   if (this.columnDefinitions.length < 10) {
    //     const action =  this.columnDefinitions.pop();
    //     this.columnDefinitions.push(
    //       { def: "userSign", showMobile: false }
    //     )
    //     this.columnDefinitions.push(
    //       { def: "role", showMobile: false }
    //     )
    //     this.columnDefinitions.push(action);
    //     this.getDisplayedColumns();
    //   }
    //
    // } else {
    //   if (this.columnDefinitions.length > 10) {
    //     const action =  this.columnDefinitions.pop();
    //     this.columnDefinitions.pop()
    //     this.columnDefinitions.pop()
    //     this.columnDefinitions.push(action);
    //     this.getDisplayedColumns();
    //   }
    // }
  }

  addColumnTable() {
    if (this.isBasicSearchForm) {
      if (this.columnDefinitions.length > 17) {
        const action = this.columnDefinitions.pop();
        this.columnDefinitions.push(action);
        this.getDisplayedColumns();
      }
    } else {
      if (!((this.documents.signRole == null || this.documents.signRole == 'null') || this.documents.nameOrEmailOrPhoneUserSign == null) && !this.isBasicSearchForm) {
        if (this.columnDefinitions.length < 16) {
          const action = this.columnDefinitions.pop();
          this.columnDefinitions.push(
            {def: 'userSign', default: true , showMD: true, showMobile: false, name: '', check: true}
          );
          this.columnDefinitions.push(
            {def: 'role', default: true , showMD: true,  showMobile: false, name: '', check: true}
          );
          this.columnDefinitions.push(action);
          this.getDisplayedColumns();
        }

      } else {
        if (this.columnDefinitions.length > 17) {
          const action = this.columnDefinitions.pop();
          this.columnDefinitions.push(action);
          this.getDisplayedColumns();
        }
      }
    }
    this.onFilterData(0, this.paginate.pageSize);
  }

  signRoleChanged(data: any) {

    if (this.documents.signRole === null || this.documents.signRole === 'null') {
      this.documents.nameOrEmailOrPhoneUserSign = null;
      this.documents.signRole = null;
      this.isDisableNamePhoneEmail = true;
    } else {
      this.isDisableNamePhoneEmail = false;
    }
    this.ngForm.control.markAllAsTouched();
  }

  /**
   * Open screen add document
   */
  onAddDocument() {
    this.toNavigate('/home-enterprise/add-document/');
  }

  /**
   * Open advanced search form
   */
  onExpandAdvancedSearchForm() {
    this.isBasicSearchForm = false;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Close advanced search form
   */
  onCloseAdvancedSearchForm() {
    this.isBasicSearchForm = true;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Set params for to navigate
   */
  toNavigate(route, params = {}) {
    let queryParams: any = {
      ...params,
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize,
      routeLink: '/home-enterprise/search-document-contract-company/',
      nameOrCode: this.documents.nameOrCode,
      serviceType: this.documents.serviceType,
      customerName: this.documents.customerName,
      status: this.documents.status,
     // bctConfirmStatus: this.documents.bctConfirmStatus,
      sortColumn: this.sortColumn,
      signRole: this.documents.signRole,
      sortDirection: this.sortDirection
    };

    if (!this.isBasicSearchForm) {
      queryParams = {
        ...queryParams,
        serviceType: this.documents.serviceType,
        taxCode: this.documents.taxCode,
        createdUser: this.documents.createdUser,
        createdTimeFrom: this.documents.createdTimeFrom,
        createdTimeTo: this.documents.createdTimeTo,
        mohaConfirmStatus: this.documents.mohaConfirmStatus,
        mohaStatus: this.documents.mohaStatus
      };
    }

    if(this.checkPermissionLimitedViewContract()){
      queryParams = {
        ...params,
        page: this.paginate.currentPage,
        pageSize: this.paginate.pageSize,
        routeLink: '/home-enterprise/search-document-contract-company/',
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
        certificateNo: this.documents.certificateNo,
        contractCodeName: this.documents.contractCodeName,
      }
    }

    this.router.navigate([route], {queryParams});
  }

  isAllSelected() {
    const selecteds = this.selection.selected;
    const dataSourceIds = this.dataSource.data.value.map(d => d.id);
    const intersectionArr = dataSourceIds.filter(data => selecteds.includes(data));
    return intersectionArr.length === dataSourceIds.length;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    const dataSourceIds = this.dataSource.data.value.map(ds => ds.id);
    this.isAllSelected() ?
      this.selection.deselect(...dataSourceIds) :
      this.selection.select(...dataSourceIds);
  }

  /** Return customer group by format <customer group name 1>, <customer group name 2>. */
  transformListCustomerGroupToString(customerGroups: CustomerGroup[]){
    return ((customerGroups && customerGroups.length > 0) ? customerGroups : []).map(value => value.name).join(", ");
  }

  getColorTagExpireStatus(expireStatus) {
    let color = ''
    switch (expireStatus) {
      case '1':
        color = 'blue'
        break
      case '2':
        color = 'orange'
        break
      case '3':
        color = 'red'
        break
    }
    return color
  }

  checkPermissionCreateContract() {
    const permissions = localStorage.getItem('permissions');
    if(this.commonService.checkDefaultAdmin()) {
      return true;
    }
    if(permissions.includes('12')) {
      return true;
    }
    return false;
  }

  checkPermissionLimitedViewContract() {
    const permissions = localStorage.getItem('permissions');
    if(this.commonService.checkDefaultAdmin()) {
      return false;
    }
    if(permissions.includes('501') && permissions.includes('5')) {
      return true;
    }
    return false;
  }

  getMethodCreation(typeId: any){
    if(typeId == 1){
      return this.message.getMessage('search_form.upload')
    } else if (typeId == 0) {
      return this.message.getMessage('search_form.template')
    } else {
      return ''
    }
  }

  terminationContract(element){
    this.blockUI.start()
    this.documentService.checkContractTermination(element.id).subscribe(rs => {
      this.blockUI.stop()
      if(rs.success){
        const dialogRef = this.dialog.open(ConfirmTerminationComponent, {
          data: this.message.getMessage('contract_terminate.use_old_signflow')
        })
        dialogRef.afterClosed().subscribe(res =>{
          if(res){
            this.toNavigate('/home-enterprise/update-document/' + element.id, {
              termination: true,
              goFrom: 'mine',
              terminationType: res === 'NEW' ? 1 : 2
            });
          }
        })
      } else {
        this.toastr.error(rs.message)
      }
    })
  }

  getFormType(formType: string){
    if(formType == 'CONTRACT'){
      return this.message.getMessage('contract_terminate.contract')
    } else if (formType == 'CONTRACT_TERMINATION') {
      return this.message.getMessage('contract_terminate.terminate')
    } else {
      return ''
    }
  }

  changeContractStatus(){
    if(this.documents.status == this.enumContractStatus.TERMINATED || this.documents.status == this.enumContractStatus.TERMINATING){
      this.documents.formType = 'CONTRACT'
      this.cdr.detectChanges()
    }
    this.onClickBtnFilter()
  }

  reAuthenticate(id: string) {
    this.documentMohaService.reTryAuthenMessage(id).subscribe(res => {
      if (!res.success) {
        this.toastr.error(this.message.getMessage('messages.re_authentication_fail'));
      } else {
        this.toastr.success(this.message.getMessage('messages.re_authentication_success'));
        this.loadData();
      }
    })
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}

export class Document {
  STT?: number;
  name: string; //
  id: string; //
  code: string; //
  createdTime: any;
  createdTimeFrom: string;
  createdTimeTo: string;
  finishDate: string;
  finishDateFrom: string;
  finishDateTo: string;
  createdUser: string;
  customerName: string;
  taxCode: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  customerGroups: CustomerGroup[]; // Nhóm khách hàng
  status: any;
  signRole: any;
  nameOrEmailOrPhoneUserSign: string;
  parentId: string;
  enterprise: string;
  documentType: any;
  serviceType: any;
  email: string;
  hasChildren: boolean;
  nameOrCode: string;
  typeId: string;
  isDifferentEnterprise: boolean;
  createdEnterpriseName: string;
  //bctConfirmStatus: number | string;
  isConfirmBCT: boolean;
  submittedByATime: Date;
  expireStatus: string;
  contractCodeName: string;
  certificateNo: string;
  formType: string;
  // 1 không được phân quyền ký
  // 2 được phân quyền ký
  // 3 chỉ xem và copy
  // is parent element
  permission: number;

  // DRAFT(0),
  // WAIT_1(1),
  // SINGED_1(2),
  // REJECT_1(3),
  // WAIT_2(4),
  // SINGED_2(5),
  // REJECT_2(6);
  // Finish (7); ?
  // 0 - Nháp
  // 1- Chờ ký bên lập
  // 2 - Đã ký bên lập
  // 3 - Từ chối bên lập
  // 4 - Chờ ký bên nhận
  // 5 - Ký bên nhận
  // 6 - Từ chối bên nhận
  // 7 - HOÀN THÀNH
  // 8 - Mới gởi qua bên nhận

  uuidContractMoha: string;
  mohaStatus: number;
  mohaConfirmStatus: number;

  // hồi sửa lại sau
  getPermission(): void {
    if (this.status === 3 || this.status === 6 // reject
      || this.status === 1 // được ký bởi bên lập
      || this.status === 7) { // Finish
      this.permission = 3;
    } else if (this.status === 1 || this.status === 4) {
      this.permission = 2;
    } else {
      this.permission = 1;
    }
  }
}

export class SortKeyPair {
  /* @ViewChild(MatSort, { static: false }) sort: MatSort; */
  [key: string]: MatSort;
}

export class BooleanKeyPair {
  [key: string]: boolean;
}

export class StringKeyPair {
  [key: string]: string;
}

export class DocumentKeyPair {
  [key: string]: Document;
}

export class DocumentTypeDataSourceKeyPair {
  [key: string]: DocumentDataSource;
}

export class PaginateKeyPair {
  [key: string]: Paginate;
}

export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  constructor() {
    super();
  }


  setData(data: Document[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}

/** Create CustomerGroup Type. */
export class CustomerGroup{
  id?: string;
  name?: string;
}
